import type { ReactNode } from 'react'

import { faClock } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { Banner } from '@b-stock/fe-core/bstock-react'
import { Colors } from '@b-stock/fe-core/design-system'

// fe-core's Banner hardcodes an info-circle per type, so the icon is suppressed
// and a clock supplied here instead; the container, tint, border and body type
// all still come from Banner.
const StyledBanner = styled(Banner)`
  align-items: flex-start;
`

const Content = styled.span`
  align-items: flex-start;
  display: flex;
  gap: 0.5rem;
`

const ClockIcon = styled(FontAwesomeIcon)`
  color: ${Colors.Semantic.Info.highlight};
  flex-shrink: 0;
  font-size: 1rem;
  height: 1.25rem;
`

/**
 * The shared treatment for the ACH clearing notice on every pre-purchase
 * surface — the listing panel, both confirm dialogs, the change-payment dialog
 * and Checkout. Informational only: no dismiss control and no checkbox.
 */
export const AchProcessingNotice = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => (
  <StyledBanner type="info" narrow hideIcon className={className}>
    <Content>
      <ClockIcon icon={faClock} />
      <span>{children}</span>
    </Content>
  </StyledBanner>
)
